import React from "react";
import Icon from "components/AppIcon";
import { LineChart, Line, ResponsiveContainer } from "recharts";

const sparkData = [
  [{ v: 6.2 }, { v: 6.8 }, { v: 7.1 }, { v: 6.9 }, { v: 7.4 }, { v: 7.8 }],
  [{ v: 5.1 }, { v: 5.4 }, { v: 5.2 }, { v: 5.8 }, { v: 6.1 }, { v: 6.3 }],
  [{ v: 14.2 }, { v: 13.8 }, { v: 13.5 }, { v: 13.1 }, { v: 12.9 }, { v: 12.6 }],
  [{ v: 18.4 }, { v: 19.1 }, { v: 20.3 }, { v: 21.2 }, { v: 22.8 }, { v: 24.1 }],
];

const metrics = [
  {
    label: "Cash-on-Cash Return",
    value: "7.8%",
    benchmark: "Mkt Avg: 5.4%",
    trend: "+2.4%",
    positive: true,
    icon: "Percent",
    color: "var(--color-secondary)",
    sparkIdx: 0,
  },
  {
    label: "Cap Rate",
    value: "6.3%",
    benchmark: "Mkt Avg: 5.1%",
    trend: "+1.2%",
    positive: true,
    icon: "TrendingUp",
    color: "var(--color-primary)",
    sparkIdx: 1,
  },
  {
    label: "Gross Rent Multiplier",
    value: "12.2x",
    benchmark: "Mkt Avg: 13.8x",
    trend: "-1.6x",
    positive: true,
    icon: "BarChart2",
    color: "var(--color-warning)",
    sparkIdx: 2,
  },
  {
    label: "Total Return (5yr)",
    value: "24.1%",
    benchmark: "Mkt Avg: 17.6%",
    trend: "+6.5%",
    positive: true,
    icon: "DollarSign",
    color: "var(--color-success)",
    sparkIdx: 3,
  },
];

export default function MetricsStrip() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {metrics?.map((m) => (
        <div key={m?.label} className="card-base flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <div
              className="flex items-center justify-center w-9 h-9 rounded-lg"
              style={{ background: `${m?.color}18` }}
            >
              <Icon name={m?.icon} size={18} color={m?.color} />
            </div>
            <span
              className={`text-xs font-caption font-semibold px-2 py-0.5 rounded-full ${
                m?.positive
                  ? "bg-success/10 text-success" :"bg-accent/10 text-accent"
              }`}
            >
              {m?.trend}
            </span>
          </div>
          <div>
            <p className="text-xs font-caption text-muted-foreground">{m?.label}</p>
            <p className="text-2xl font-heading font-bold text-foreground font-mono-data">
              {m?.value}
            </p>
            <p className="text-xs font-caption text-muted-foreground mt-0.5">
              {m?.benchmark}
            </p>
          </div>
          <div className="h-10">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={sparkData?.[m?.sparkIdx]}>
                <Line
                  type="monotone"
                  dataKey="v"
                  stroke={m?.color}
                  strokeWidth={2}
                  dot={false}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      ))}
    </div>
  );
}